import { render, staticRenderFns } from "./compare_versions.vue?vue&type=template&id=5f3c28c6"
import script from "./compare_versions.vue?vue&type=script&lang=js"
export * from "./compare_versions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports